export default __webpack_public_path__ + "static/media/water_300ml.a0035134.jpg";